







import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

import SidebarMenuItem from '../SidebarMenuItem.vue';

import RiskResourcesService from '@/services/RiskResources';

@Component( {
	name: 'SidebarMenu',
	components: {
		SidebarMenuItem
	}
} )
export default class SidebarMenu extends Vue {
	@State('menu', { namespace: 'RiskResources' }) private menuItems: any;
	private RiskResourcesService: typeof RiskResourcesService = RiskResourcesService;
}
